import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import { i18n, initFlySafeI18n } from './flysafe/utils/i18n';

initFlySafeI18n();

const container = document.getElementById('app');
const root = createRoot(container as HTMLElement);
root.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>,
);
